<div class="mt-2">
  <app-base-card [cardTitle]="'HOME.CLOSED' | transloco" [cardIcon]="'lock-closed-outline'">
    <ion-label color="dark" class="whitespace-pre-wrap">{{ 'HOME.CLOSED_WALLET' | transloco }}</ion-label> 
  </app-base-card>
</div>